import { render, staticRenderFns } from "./ProfilePreview.vue?vue&type=template&id=6546ba3d&scoped=true"
import script from "./ProfilePreview.vue?vue&type=script&lang=js"
export * from "./ProfilePreview.vue?vue&type=script&lang=js"
import style0 from "./ProfilePreview.vue?vue&type=style&index=0&id=6546ba3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6546ba3d",
  null
  
)

export default component.exports